import { withAuthorization } from "../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../structure/Page/DefaultPage/DefaultPage";

const GlobalSettingsPageContent = lazy(() => import("./GlobalSettingsPageContent"));

function GlobalSettingsPageInternal() {
    return (
        <DefaultPage>
            <GlobalSettingsPageContent />
        </DefaultPage>
    );
}

export const GlobalSettingsPage = withAuthorization(getAuthorizationGuard(Role.ADMIN, Role.OWNER))(
    GlobalSettingsPageInternal
);
